import React, { memo, useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import { ADS_DATA } from '@/types/interfaces';

import HomeAdsItem from '../Home/Components/HomeAdsItem';

import TopCity from './Components/TopCity';
import AdsDetailsMoreInfo from './Components/AdsDetailsMoreInfo';
import Details from './Components/Details';
import DetailBreadcrumb from './Components/DetailBreadcrumb';

function Index({ adsDetail, adsData }: any) {
  const children = useMemo(() => {
    return (
      <>
        {adsData?.map((ads: ADS_DATA) => (
          <Col key={ads.id} md={3}>
            <HomeAdsItem adsDetail={ads} />
          </Col>
        ))}
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adsData]);
  return (
    <>
      <DetailBreadcrumb adsDetail={adsDetail} />
      <section className="ads-detail-sec">
        <div className="container">
          <Details adsDetail={adsDetail} />
          <TopCity queryData={{ category: 'escorts' }} />
          <AdsDetailsMoreInfo city={adsDetail?.city} />
          <div className="our-top-wrap">
            <Container>
              <h2>Similar Profiles</h2>
              <div className="top-inner-wrap">
                <Row className="top-cg-row">{children}</Row>
              </div>
            </Container>
          </div>
        </div>
      </section>
    </>
  );
}

export default memo(Index);
